import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {CustomService} from "../../providers/custom.service";
import {Subscription} from "rxjs";
import {IonSelect, ModalController} from "@ionic/angular";
import {CommonUtils} from "../../utils/common";
import CSVFields from "../../../assets/csv-report-fields.json";

@Component({
  selector: 'app-vet-clinic-custom-modal',
  templateUrl: './vet-clinic-custom-modal.component.html',
  styleUrls: ['./vet-clinic-custom-modal.component.scss'],
})
export class VetClinicCustomModalComponent implements OnInit {


  @Input() vetCodeId;
  @Input() title;

  customSub: Subscription;
  customFields: any[];
  vetReservationSelectHeader: any = {
    header: 'Wybierz pola z rezerwacji'
  };
  orderSelectHeader: any = {
    header: 'Wybierz pola z zamówienia'
  };
  pickedVetReservationSelectOptions: any = [];
  pickedOrderSelectOptions: any = [];
  allSelectOptions: any;
  vetReservationSelectOptions: any;
  orderSelectOptions: any;
  isLoading = true;



  constructor(private customService: CustomService,
              private modalController: ModalController,
              private commonUtils: CommonUtils) { }

  ngOnInit() {

    this.allSelectOptions = CSVFields;
    this.vetReservationSelectOptions = this.allSelectOptions.filter(reportField => reportField.objectType === 'VetReservation');
    this.orderSelectOptions = this.allSelectOptions.filter(reportField => reportField.objectType === 'Order');
    this.customSub = this.customService.getCustom(this.vetCodeId, 'today').subscribe(response => {
      if (response !== undefined && 'fields' in response) {
        this.customFields = JSON.parse(response.fields);
      } else {
        this.customFields = [];
      }
      this.isLoading = false;
      this.pickedVetReservationSelectOptions = this.customFields.
        filter(customField => customField.objectType === 'VetReservation').
        map(e => e.field);
      this.pickedOrderSelectOptions = this.customFields.
        filter(customField => customField.objectType === 'Order').
        map(e => e.field);
      console.log(this.customFields);
      console.log(this.pickedOrderSelectOptions);
      console.log(this.pickedVetReservationSelectOptions);

    }, error => {
      this.isLoading = false;
    });


  }

  onClose() {
    this.modalController.dismiss(null);
  }

  onSubmit() {
    this.modalController.dismiss(this.getFinalReturnValues(), 'submit'); // todo uzupelnic
  }

  getFinalReturnValues() {

    const returnObj = {
      vetcodeId: this.vetCodeId,
      csvReportFields: []
    };
    const vetReservationOptions = [];
    this.vetReservationSelectOptions.forEach(vetReservationOption => {
      for (const picked of this.pickedVetReservationSelectOptions) {
        if (vetReservationOption.field === picked) {
          vetReservationOptions.push(vetReservationOption);
        }
      }
    });
    const orderOptions = [];
    this.orderSelectOptions.forEach(orderOption => {
      for (const picked of this.pickedOrderSelectOptions) {
        if (orderOption.field === picked) {
          orderOptions.push(orderOption);
        }
      }
    });
      if (orderOptions.length > 0 && vetReservationOptions.length > 0) {
        returnObj.csvReportFields = vetReservationOptions.concat(orderOptions);
      } else if (vetReservationOptions.length === 0 && orderOptions.length > 0) {
        returnObj.csvReportFields = orderOptions;
      } else if (orderOptions.length === 0 && vetReservationOptions.length > 0) {
        returnObj.csvReportFields = vetReservationOptions;
      } else {
        returnObj.csvReportFields = [];
      }
    return returnObj;
    }

  vetReservationSelectChange($event: any) {
    this.pickedVetReservationSelectOptions = $event.detail.value;
    console.log(this.pickedVetReservationSelectOptions);
  }

  orderSelectChange($event: any) {
    this.pickedOrderSelectOptions = $event.detail.value;
    console.log(this.pickedOrderSelectOptions);
  }



  translateVetReservationField(field: any) {
    return this.commonUtils.translateReservation(field);
  }

  translateOrderField(field: any) {
    return this.commonUtils.translateOrder(field);
  }

  getPickedOrderSelectOptions() {
    return this.pickedOrderSelectOptions;
  }
}
